"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("../..");
class FormStateMachine extends __1.FiniteStateMachine {
    constructor() {
        super(...arguments);
        this._state = "start";
    }
    get associatedValue() {
        switch (this.state) {
            case "showingError":
                return this.error;
            case "presenting":
                return this.item;
            default:
                return null;
        }
    }
    /**
     * Load Transition
     * [start, showingError] -- load -> [loading]
     */
    load(id) {
        switch (this.state) {
            case "start":
            case "showingError":
                this.setState("loading");
                break;
            default:
                return;
        }
        if (!id) {
            throw new Error("Not implemented");
        }
        if (id.actualObject !== undefined) {
            this.success(id.actualObject);
        }
        else {
            id.load()
                .then((result) => {
                this.success(result);
            })
                .catch((error) => {
                this.fail(error);
            });
        }
    }
    /**
     * Success Transition
     * [loading] -- success -> [presenting]
     *
     * @param items - Array of items successfully loaded
     */
    success(item) {
        switch (this.state) {
            case "loading":
                this.item = item;
                this.setState("presenting", item);
            default:
                return;
        }
    }
    /**
     * Fail Transition
     * [loading] -- fail -> [showingError]
     *
     * @param error - Error reason for failure
     */
    fail(error) {
        switch (this.state) {
            case "loading":
                this.error = error;
                this.setState("showingError", error);
            default:
                return;
        }
    }
    /**
     * Dismiss Transition
     * [presenting, showingError] -- dismiss -> completed
     */
    dismiss() {
        switch (this.state) {
            case "presenting":
            case "showingError":
                this.setState("completed");
            default: return;
        }
    }
}
exports.default = FormStateMachine;
//# sourceMappingURL=FormStateMachine.js.map